import type { FullComposeViewState } from 'owa-calendar-compose-types';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import type { CalendarEvent } from 'owa-calendar-types';
import getDatesOnStartDateChanged from 'owa-datetime-utils/lib/dateSelector/getDatesOnStartDateChanged';
import { orchestrator } from 'satcheljs';
import {
    hideCustomRecurrenceForm,
    saveCustomRecurrence,
    updateDateTimes,
    setRoomBookingAssistantEnabled,
    setRecurrence,
} from 'owa-calendar-compose-form-actions';
import { TimeChangeActionType } from 'owa-calendar-helpers-types/lib/TimeChangeActionType';
import shouldSupportAutoRoomBooking from 'owa-calendar-compose-form-store/lib/selectors/shouldSupportAutoRoomBooking';

export default orchestrator(saveCustomRecurrence, () => {
    const store = getComposeStore();
    const event: CalendarEvent = store.event;
    const fullComposeViewState: FullComposeViewState = getFullComposeViewState();
    if (fullComposeViewState) {
        const { recurrence, startDate } = fullComposeViewState.customRecurrenceViewState;

        updateDateTimes(
            getDatesOnStartDateChanged(event.Start, event.End, startDate),
            TimeChangeActionType.CustomRecurrence
        );
        setRecurrence(recurrence);

        hideCustomRecurrenceForm();

        if (!shouldSupportAutoRoomBooking()) {
            setRoomBookingAssistantEnabled(false);
        }
    }
});
